import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["height", "width", "onComplete", "onLoopComplete", "onSegmentStart"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/core/components/Lottie/index.js";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React, { Component } from 'react';
import styled from 'styled-components';
import lottie from 'lottie-web';
/**
 * Motion component renders motion graphics,
 * using Lottie
 *
 * TODO: Sudhir: Update Lottie component documentation.
 *
 */

var Lottie = /*#__PURE__*/function (_Component) {
  _inherits(Lottie, _Component);
  var _super = _createSuper(Lottie);
  function Lottie() {
    var _this;
    _classCallCheck(this, Lottie);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.refContainer = /*#__PURE__*/React.createRef();
    _this._onLoopComplete = function () {
      if (!_this.props.play) return _this.stop();
      if (_this.props.config.loop) {
        _this.play(_this.props.segments);
      } else {
        _this.pause();
      }
      _this.props.onLoopComplete && _this.props.onLoopComplete();
    };
    _this._onComplete = function () {
      if (!_this.props.play) return _this.stop();
      if (_this.props.config.loop) {
        _this.play(_this.props.segments);
      } else {
        _this.pause();
      }
      _this.props.onComplete && _this.props.onComplete();
    };
    return _this;
  }
  _createClass(Lottie, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadAnimation();
      this.updateAnimationState();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.play !== this.props.play || prevProps.pause !== this.props.pause || prevProps.segments !== this.props.segments) {
        this.updateAnimationState();
      }
      if (prevProps.animationData !== this.props.animationData) {
        this.reloadAnimation();
      }
    }
  }, {
    key: "updateAnimationState",
    value: function updateAnimationState() {
      var _this$props = this.props,
        play = _this$props.play,
        pause = _this$props.pause,
        segments = _this$props.segments;
      if (!this.anim) return;
      play ? this.play(segments) : this.stop();
      pause && this.pause();
    }
  }, {
    key: "play",
    value: function play(segments) {
      if (segments) {
        this.anim.playSegments(segments, true);
      } else {
        this.anim.play();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.anim.stop();
    }
  }, {
    key: "pause",
    value: function pause() {
      this.anim.pause();
    }
  }, {
    key: "reloadAnimation",
    value: function reloadAnimation() {
      this.stop();
      this.loadAnimation();
      this.updateAnimationState();
    }
  }, {
    key: "loadAnimation",
    value: function loadAnimation() {
      var _this$props2 = this.props,
        _this$props2$config = _this$props2.config,
        config = _this$props2$config === void 0 ? {} : _this$props2$config,
        animationData = _this$props2.animationData;
      this.anim = lottie.loadAnimation({
        container: this.refContainer.current,
        // the dom element that will contain the animation
        renderer: 'svg/canvas/html',
        loop: !!config.loop,
        autoplay: !!config.autoplay,
        animationData: animationData // animation data in JSON format.
      });

      this.anim.addEventListener('complete', this._onComplete);
      this.anim.addEventListener('loopComplete', this._onLoopComplete);
    }
  }, {
    key: "render",
    value: function render() {
      /*eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }]*/
      var _this$props3 = this.props,
        height = _this$props3.height,
        width = _this$props3.width,
        onComplete = _this$props3.onComplete,
        onLoopComplete = _this$props3.onLoopComplete,
        onSegmentStart = _this$props3.onSegmentStart,
        rest = _objectWithoutProperties(_this$props3, _excluded);
      return /*#__PURE__*/React.createElement(LottieWebAnimationCanvas, _extends({}, rest, {
        height: height,
        width: width,
        ref: this.refContainer,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 110,
          columnNumber: 7
        }
      }));
    }
  }]);
  return Lottie;
}(Component);
var LottieWebAnimationCanvas = styled.div.withConfig({
  displayName: "Lottie__LottieWebAnimationCanvas",
  componentId: "sc-ldzxic-0"
})(["position:relative;", " svg:not(:root){overflow:visible;}"], function (_ref) {
  var height = _ref.height,
    width = _ref.width;
  return {
    height: height,
    width: width
  };
});
export default Lottie;